import "./utilities_namespace.js";

// Generates a unique identifier to contain events and aria relationships within a component

window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

Sparkle.Utilities.generateUUID = () => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);

  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};
